import { Typography } from "antd";
import ProviderTable from "components/Resources/ProviderTable";
import './index.scss';

const { Title } = Typography;

const ProviderPage = () => {

  return (
    <div className="provider-page">
      <div className="header-title">
        <Title level={4} className="ml-3">Provider Resources</Title>
      </div>
      <div className="content">
        <ProviderTable />
      </div>
    </div>
  );
}

export default ProviderPage;